exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "label[data-v-017f5e85]{margin-bottom:10px}input[data-v-017f5e85],select[data-v-017f5e85],textarea[data-v-017f5e85]{display:block;width:100%;height:40px;padding-left:10px;line-height:40px;border:1px solid #d0d0d0;-webkit-appearance:none}textarea[data-v-017f5e85]{min-height:200px;height:200px}.error[data-v-017f5e85]{margin-top:10px;background:#c40063;color:#fff;padding:15px}.success[data-v-017f5e85]{background:pink;padding:15px;background:#3d75b9;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-017f5e85","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./web/app/themes/giles/resources/js/components/ContactForm.vue
// module id = 441
// module chunks = 0